const vehicle_types = [
  "Saloon/Sedan",
  "Coupe",
  "Sports Car",
  "Station Wagon",
  "Hatchback",
  "convertible",
  "SUV",
  "Mini-van",
  "Pickup",
  "Bus",
  "Trailer",
  "Motorcycle",
  "Tricycle",
  "Space Bus",
  "Scooter",
];

export default vehicle_types;
